export default "__VITE_ASSET__c944729a__"